import { nanoid } from 'nanoid'

export const getSurchargeSettingsList = (restaurant) => {
    if (restaurant && restaurant.surchargeSettings) {
      return  restaurant.surchargeSettings;
    }
    if (restaurant && restaurant.holidaySurcharge) {
      return [{
        publicHolidayDays: restaurant.holidaySurcharge.publicHolidayDays,
        weekdays: restaurant.holidaySurcharge.weekdays,
        isEnabled: restaurant.holidaySurcharge.isEnabled,
        isPercentage: restaurant.holidaySurcharge.isPercentage,
        amount: restaurant.holidaySurcharge.amount,
        name: "Holiday/weekend Surcharge",
        surchargeDescription: "Holiday/weekend Surcharge",
        id: 'holidaySurcharge',
      }];
    }
    return [];
 } 

// A payment type's surcharge rate is a percentage. Negative rates are allowed and
// act as a discount for that payment type (e.g. -2 for a cash discount).
export const SURCHARGE_RATE_MIN = -100;
export const SURCHARGE_RATE_MAX = 100;

export const SURCHARGE_RATE_ERROR = `Surcharge rate must be a number between ${SURCHARGE_RATE_MIN} and ${SURCHARGE_RATE_MAX}`;

// A blank field means "no surcharge".
export const parseSurchargeRate = (value) => {
  if (value === "" || value === null || value === undefined) {
    return 0;
  }
  return Number(value);
};

export const isValidSurchargeRate = (value) => {
  const rate = parseSurchargeRate(value);
  return (
    Number.isFinite(rate) &&
    rate >= SURCHARGE_RATE_MIN &&
    rate <= SURCHARGE_RATE_MAX
  );
};
